import React from 'react';
import { Page, LandingContainer } from '@containers/layout';
import { Heading, IconButton, LinkText } from '@components/common';
import ForgotForm from '@containers/auth/ForgotForm';
import history from '@utils/history';

export default function ForgotPage() {
  const renderBackButton = () => {
    return (
      <IconButton
        onClick={() => {
          history.goBack();
        }}
        name="back"
        width={16}
        height={16}
        title="Back"
      />
    );
  };

  return (
    <Page renderHeaderLeftButtons={renderBackButton}>
      <LandingContainer
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Heading mb={1}>Forgot your password?</Heading>
        <ForgotForm />
        <LinkText
          mb={7}
          textAlign="center"
          onClick={() => {
            history.push('/auth/register');
          }}
        >
          Create an Account
        </LinkText>
      </LandingContainer>
    </Page>
  );
}
